import React from 'react'
import PropTypes from 'prop-types'
import { Error } from '../common/Errors'

export default function NotFound({ message, errorCode }) {
  return <Error customMessage={message} errorCode={errorCode} />
}

NotFound.propTypes = {
  message: PropTypes.string,
  errorCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

NotFound.defaultProps = {
  message: undefined,
  errorCode: 404
}
